import angular from 'angular';
import './filter.component.js';
import './docrepo-invoice.service.js';
import './grid.component.js';
import './detail/docrepo-invoice-tabs.component.js';

class DocrepoInvoiceListCtrl {
    /*@ngInject*/
    constructor($sessionStorage, logger, DocrepoInvoicesSvc) {
        this.$sessionStorage = $sessionStorage;
        this.logger = logger;
        this.DocrepoInvoicesSvc = DocrepoInvoicesSvc;
        this.gridParams = {};
        this.gridParams.paginationPageSizes = [20, 50, 100];
        this.gridParams.paginationPageSize = 20;
        this.data = {};
    }

    $onInit() {
        if (this.$sessionStorage.listKissInvoicesCriteria) {
            this.criterias = this.$sessionStorage.listKissInvoicesCriteria;
        } else {
            this.criterias = {};
        }
    }

    /**
     * Lancer la recherche vers le serveur.
     */
    search() {
        let vm = this;
        this.$sessionStorage.listKissInvoicesCriteria = this.criterias;

        let preparedSearchFilter = this.DocrepoInvoicesSvc.createFilter(this.criterias, this.gridParams);
        this.searchPromise = this.DocrepoInvoicesSvc.searchInvoices(preparedSearchFilter);

        this.searchPromise.then(
            function(data) {
                vm.data = data;
                vm.gridSize = data.totalItems;
            },
            function(error) {
                vm.logger.error('error.generic', error);
            }
        );
    }
}

angular.module('app.docrepo_invoice').component('docrepoInvoiceList', {
    templateUrl: require('./docrepo-invoice-list.html'),
    controller: DocrepoInvoiceListCtrl
});
